import store from '../../../redux/store.ts'
import { actions } from '../slice.ts'

export function show(text: string, isError = true, duration = 5_000) {
	store.dispatch(
		actions.notificationUse({
			error: isError,
			status: true,
			text
		})
	)
	setTimeout(() => {
		store.dispatch(
			actions.notificationUse({
				error: isError,
				status: false,
				text: ''
			})
		)
	}, duration)
}
